import { Input } from 'antd';
import React, { FC } from 'react';

type TAdministratorItem = {
  value?: string;
  onChange?: (value?: string) => void;
};

const AdministratorsItem: FC<TAdministratorItem> = (props) => {
  const { value, onChange } = props;
  return (
    <div>
      <Input defaultValue={value} onChange={(e) => onChange?.(e.target.value)} />
      <div>
        可以设置其他需要管理该打卡营的用户作为共同管理员，请输入uid，多个uid之间用英文逗号分隔
      </div>
    </div>
  );
};
export default AdministratorsItem;
